<template>
  <div id="LayPeriodicalJournal">
    <div class="LayPeriodicalJournal_box">
      <div v-if="!isNo&&el.child&&el.child.length" class="LayPeriodicalJournal"
           v-for="(el,inds) in list" :key="inds">
        <div v-if="el.child&&el.child.length" class="left_Title" >
          <p>
            <i class="iconfont iconjieguo"></i>
            <span v-if="el.titlelang.mn" class="aqt_lang_mn titlefont titlespan">{{ el.titlelang.mn|U2M }}</span>
            <span v-else class="titlefont aqt_su titlespan">{{ el.titlelang.zh|U2M }}</span>
            <span class="title_more titlefont aqt_lang_mn" @click="goJournal(el)">{{
                $t('m.gend_more') + '>>'|U2M
              }}  </span>
          </p>
          <p></p>
        </div>
        <div class="list_Content aqt_su">
          <div class="aqt_list_lists_one" v-for="(item,index) in el.child" :key="index"
               @click.stop="getDetail(item.periodical_id,item.isxq)">
            <div class="aqt_top aqt_ce_ve" v-if="item.img">
              <img v-lazy="item.img?$webcrypto.get(item.img):''" alt/>
              <p v-if="item.number" class="periodical_num aqt_no_su">{{ item.number }}</p>
            </div>
            <div class="aqt_center">
              <!-- 期刊名字 -->
              <div class="aqt_title" v-if="item.titlelang&&(item.titlelang.mn||item.titlelang.zh)">
                <p v-if="item.titlelang.mn" class="titlefont aqt_lang_mn"
                   v-html="U2M(item.titlelang.mn)"></p>
                <p v-else class="titlefont aqt_su"
                   v-html="U2M(item.titlelang.zh)"></p>
              </div>

            </div>
          </div>
          <div style="clear: both"></div>
        </div>
      </div>

      <div v-if="isNo&&!list.length" class="nomassage">
        <p class="aqt_lang_mn titlefont">{{ $t('m.noData') | U2M }}</p>
      </div>

      <!--    加载动画-->
      <AqtSpin v-if="isSpin"></AqtSpin>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      isSpin: false,
      list: [],
      query: {
        library_id: '',
        title: '',//书名
        type:'one',//all 全部期刊列表 全部杂志入口  one树状杂志 当前馆藏杂志
        keyword:'',//关键词
        issn:'',
        editor:'',//主编
        deputy_editor:'',//副主编
        keymn:'',//首字母
        magazineclass_id:'',//分类id
      },
      isNo: false
    }
  },
  methods: {
    getDetail(id, isxq) {
      let that = this
      if (isxq == 0) {
        that.$Message.warning(that.$t('m.no_permission'));
        return
      }
      let cond = {
        id: id
      }
      that.$emit('getToDeatils', cond, 'JournalDetails')
    },
    getList() {
      let that = this
      that.list = []
      that.isSpin = true
      that.query.library_id = that.library_id
      that.$httpsencrypt.post(`api/web/v3/magazine/groupindex`, that.query)
          .then((val) => {
            if (val.code == 200 && val.data.length) {
              that.list = val.data
              that.isSpin = false
              that.isNo = false
            } else {
              that.list = []
              that.isNo = true
              that.isSpin = false
              that.total = 0
            }

          }).catch(e => {
            that.list = []
            that.isNo = true
            that.isSpin = false
            that.total = 0
          }
      )
    },
    goJournal(item) {
      let that = this
      that.$store.dispatch('saveUserBehavior', {
        type: 2,
        path: that.$route.path,
        mark: '点击' + (item.titlelang.zh || item.titlelang.mn) + '更多按钮'
      }).then(() => {
      })

      let data = {
        data: '',
        id: item.magazine_id,
        type: 'one'
      }
      that.$emit('goJournal', data)

    },

    //父组件调用请求数组
    ParentCom(val) {
      let that = this
      that.isNo = false
      that.query.title = val.title
      that.query.magazine_id=val.magazine_id
      that.query.keyword=val.keyword
      that.query.issn=val.issn
      that.query.editor=val.editor
      that.query.deputy_editor=val.deputy_editor
      that.query.keymn=val.keymn
      that.query.magazineclass_id=val.magazineclass_id
      that.getList()
    },

  },
  created() {
    this.$emit('getWidth')
    this.$e
    let info = {
      type: 2,
      path: this.$route.path,
      mark: '杂志-期刊',
    }
    this.$store.dispatch('saveUserBehavior', info).then(() => {
    })
  },
  mounted() {
  },
  computed: {
    // 馆藏id
    library_id() {
      let vv = localStorage.getItem("theme_color") ? JSON.parse(this.$crypto.get(localStorage.getItem("theme_color"))).library_id : 28;
      return vv
    },
    // 用户id
    member_id() {
      let mm = localStorage.getItem("userInfoMemberId") ? JSON.parse(this.$crypto.get(localStorage.getItem("userInfoMemberId"))).member_id : ''
      return mm
    },
  },
}
</script>

<style lang="less" scoped>
#LayPeriodicalJournal {
  width: 100%;
  height: 100%;
  display: -webkit-box;
  overflow-y: hidden;

  .nomassage {
    padding: 0 1rem;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-pack: center;
    display: -ms-flexbox;
    display: flex;
    font-size: 2rem;
    color: #888888;
  }

  .LayPeriodicalJournal_box {
    width: 100%;
    height: 100%;
    display: -webkit-box;
    overflow-x: auto !important;
    overflow-y: hidden;
    position: relative;

    .LayPeriodicalJournal {
      height: 100%;
      display: -webkit-box;
      position: relative;
      margin-right: 20px;

      .left_Title {
        width: 54px;
        height: 100%;
        background: #ffffff;
        margin-right: 5px;
        padding-top: 27px;
        display: flex;
        justify-content: flex-end;


        p:nth-child(1) {
          width: 24px;
          height: 100%;
          padding-bottom: 100px;
          color: var(--themeColor);
          font-size: 20px;
          line-height: 24px;
          position: relative;
          display: flex;
          flex-direction: column;

          .titlespan {
            height: calc(100% - 20px);
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }

          i {
            font-size: 24px;
          }

          .title_more {
            position: absolute;
            bottom: 12px;
            font-size: 14px;
            left: 0;
            cursor: pointer;
            color: #888888;
          }

          .title_more:hover {
            color: var(--themeColor);
          }
        }

        p:nth-child(2) {
          width: 8px;
          height: 162px;
          background: var(--themeColor);
          margin-left: 10px;
        }


      }

      .list_Content {
        width: calc(100% - 60px);
        height: 100%;

        .aqt_list_lists_one {
          width: 20rem;
          height: 20rem;
          background-color: #ffffff;
          cursor: pointer;
          box-shadow: 1rem 1.2rem 1.5rem -1.5rem;
          border-radius: 0.3rem;
          margin-right: 1.5rem;
          margin-bottom: 1.5rem;
          float: left;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: center;

          .aqt_top {
            width: calc(100% - 6.3rem);
            height: 100%;
            position: relative;
            overflow: hidden;
            padding: 15px 0 15px 15px;


            img {
              height: auto;
              width: 100%;
              display: inline-flex;
            }

            img[lazy="loading"] {
              height: auto !important;
            }

            .periodical_num {
              width: calc(100% - 15px);
              height: 30px;
              position: absolute;
              left: 15px;
              bottom: 15px;
              background: rgba(0, 0, 0, 0.4);
              color: #ffffff;
              font-size: 15px;
              line-height: 30px;
              text-align: center;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
          }

          .aqt_center {
            height: 100%;
            width: 6.3rem;
            padding: 1.5rem 0;
            overflow: hidden;
            display: flex;
            flex-direction: column;
            //margin-right: 1rem;

            .aqt_lang_mn1 {
              writing-mode: vertical-lr;
            }

            .aqt_title {
              width: 6.3rem;
              height: 100%;
              color: #888888;
              //display: table;
              overflow: hidden;
              padding: 0 0.4rem;
              //margin: 0 0.4rem 0 0rem;

              span {
                line-height: 3.1rem;
                font-size: 1.8rem;
                margin-bottom: 1rem;
              }

              p {
                width: 6rem;
                line-height: 2.8rem;
                font-size: 1.8rem;
                height: 100%;
                display: table-cell;
                vertical-align: middle;
              }
            }

          }

        }

        .aqt_list_lists_one:hover {
          background: #F7FAF1;
        }
      }
    }
  }


}

.LayPeriodicalJournal_box::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 12px;
}

.LayPeriodicalJournal_box::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 5px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.2);
}

.LayPeriodicalJournal_box::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}
</style>
